import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import EtlToooling from '../../../tooling/etlTooling';
import Constants from '../../../definitions/constants';
import toastr from 'toastr';

import GlassPopup from '../common/interface/glassPopup';
import TextBox from '../common/inputs/textBox';
import Select from '../common/inputs/select';
import HoverTooltip from '../common/interface/hoverTooltip';

const initialObjectStates = {
  default: {
    transformation_type: "",
    order: "",
  },
  COLUMN_MAPPING: {
    transformation_type: Constants.selectKeys.metricsGroupEtl.etlTransformations.COLUMN_MAPPING,
    order: 0,
    new_column_name: "",
    new_column_order: ""
  },
  COLUMN_PIVOT_MAPPING: {
    transformation_type: Constants.selectKeys.metricsGroupEtl.etlTransformations.COLUMN_PIVOT_MAPPING,
    new_column_choice: Constants.selectKeys.metricsGroupEtl.mappingColumnPivotOptions.PIVOT,
  },
  REPLACE: {
    transformation_type: Constants.selectKeys.metricsGroupEtl.etlTransformations.REPLACE,
    order: "",
    text_to_replace: "",
    new_text: ""
  },
  CHILEANRUTFORMAT: {
    transformation_type: Constants.selectKeys.metricsGroupEtl.etlTransformations.CHILEANRUTFORMAT,
    order: "",
  },
  UNIXTIMETODATETIME: {
    transformation_type: Constants.selectKeys.metricsGroupEtl.etlTransformations.UNIXTIMETODATETIME,
    order: "",
  },
  EXTRACT: {
    transformation_type: Constants.selectKeys.metricsGroupEtl.etlTransformations.EXTRACT,
    order: "",
    extract_start_type: "",
    extract_start_value: "",
    extract_start_deviation: "",
    extract_end_type: "",
    extract_end_value: "",
    extract_end_deviation: ""
  },
  MAPCOLUMNWITHHASHMETRIC: {
    transformation_type: Constants.selectKeys.metricsGroupEtl.etlTransformations.MAPCOLUMNWITHHASHMETRIC,
    order: "",
    metric_to_map: "",
    mapping_column: "",
    result_column: "",
    default_value: "",
  },
  UPPERCASE: {
    transformation_type: Constants.selectKeys.metricsGroupEtl.etlTransformations.UPPERCASE,
    order: "",
  },
  LOWERCASE: {
    transformation_type: Constants.selectKeys.metricsGroupEtl.etlTransformations.LOWERCASE,
    order: "",
  },
}

class EtlTransformationsEditorPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toAddObject: JavascriptUtilsTooling.deepCopy(initialObjectStates.default),      
      toEditObjectPosition: null,   
      toEditObject: JavascriptUtilsTooling.deepCopy(initialObjectStates.default),
    };
  }
  
  componentDidUpdate(prevProps, prevState) {
    if(!prevState.showOverlay && this.state.showOverlay) {
      InterfaceTooling.bringObjectEditorInputIntoView();
    }
  }
  
  isValidObject = (object) => {    
    toastr.options = Constants.interface.tostrOptions;
    if(object.order && (object.order<1 || !Number.isInteger(+object.order))) {
      toastr.error(intl.formatMessage({id:"metricsGroupAdmin.etlColumnsTransformationsEditor.errorMessages.order"}));
      return false;
    }
    switch(object.transformation_type){
      case "":
        toastr.error(intl.formatMessage({id:"metricsGroupAdmin.etlColumnsTransformationsEditor.errorMessages.emptyTransformationType"}));
        return false;
      case Constants.selectKeys.metricsGroupEtl.etlTransformations.COLUMN_MAPPING:
        if(!object.new_column_name) {
          toastr.error(intl.formatMessage({id:"metricsGroupAdmin.etlColumnsTransformationsEditor.errorMessages.newColumnName"}));
          return false;
        }
        else if(this.newColumnNameIsUsedByOriginal(object.new_column_name)){
          toastr.error(intl.formatMessage({id:"metricsGroupAdmin.etlColumnsTransformationsEditor.errorMessages.newColumnNameUsed"}));
          return false;
        }
        break;
      case Constants.selectKeys.metricsGroupEtl.etlTransformations.REPLACE:
        if(!object.text_to_replace) {
          toastr.error(intl.formatMessage({id:"metricsGroupAdmin.etlColumnsTransformationsEditor.errorMessages.replace"}));
          return false;
        }
        break;
      case Constants.selectKeys.metricsGroupEtl.etlTransformations.EXTRACT:
        if(!object.extract_start_type || !object.extract_end_type || !object.extract_start_value || !object.extract_end_value ) {
          toastr.error(intl.formatMessage({id:"metricsGroupAdmin.etlColumnsTransformationsEditor.errorMessages.extractEmptyValues"}));
          return false;
        }
        if((object.extract_start_type == Constants.selectKeys.metricsGroupEtl.extractIntervalSelectorType.INDEX && !Number.isInteger(+object.extract_start_value)) ||
          (object.extract_end_type == Constants.selectKeys.metricsGroupEtl.extractIntervalSelectorType.INDEX && !Number.isInteger(+object.extract_end_value))){
          toastr.error(intl.formatMessage({id:"metricsGroupAdmin.etlColumnsTransformationsEditor.errorMessages.extractIndexType"}));
          return false;
        }
        break;
      case Constants.selectKeys.metricsGroupEtl.etlTransformations.MAPCOLUMNWITHHASHMETRIC:
        if(!object.metric_to_map || !object.mapping_column || !object.result_column) {
          toastr.error(intl.formatMessage({id:"metricsGroupAdmin.etlColumnsTransformationsEditor.errorMessages.mapColumnWithHashMetricEmptyValues"}));
          return false;
        }
        else if(object.mapping_column == object.result_column){
          toastr.error(intl.formatMessage({id:"metricsGroupAdmin.etlColumnsTransformationsEditor.errorMessages.mapColumnWithHashMetricSameColumns"}));
          return false;
        }
        break;
      case Constants.selectKeys.metricsGroupEtl.etlTransformations.COLUMN_PIVOT_MAPPING:
        if(!object.new_column_choice) {
          toastr.error(intl.formatMessage({id:"metricsGroupAdmin.etlColumnsTransformationsEditor.errorMessages.columnPivotMappingEmptyChoice"}));
          return false;
        }
        break;
      default:
        break;
    }
    return true;
  };

  newColumnNameIsUsedByOriginal = (objectNewColumnName) => {
    let trimedNewColumnName = objectNewColumnName.trim();
    return EtlToooling.getEtlTransformationsColumnOptions(this.props.metricsList, this.props.formData, "metrics_group.metrics", "metrics_group.etl_definition")[0].find(columnOption => (trimedNewColumnName!="" && columnOption.label.toUpperCase()==trimedNewColumnName.toUpperCase()));
  };
    
  handleAddButtonClick = (event) => {
    if(this.editItemInput) {
      this.editItemInput.focus();
    }
  };

  handleCancelAdd = (event) => {
    this.setState({
      showOverlay: false,
      toAddObject: JavascriptUtilsTooling.deepCopy(initialObjectStates.default)
    });
  };

  handleChangeAddItem = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    if(event.currentTarget.dataset.path == "transformation_type"){
      this.setState({
        toAddObject: {...initialObjectStates[value], order: this.state.toAddObject.order},
        showOverlay: true,
      });
    }
    else{
      var toAddObject = JavascriptUtilsTooling.deepCopy(this.state.toAddObject);
      toAddObject[event.currentTarget.dataset.path] = value;
      this.setState({
        toAddObject: toAddObject,
        showOverlay: true,
      });  
    }    
  };

  handleOnEnterAddItem = (event) => {
    if(this.addItemSaveButton) {
      this.addItemSaveButton.click();
    }  
  };

  handleSaveAddItem = (event) => {
    if(this.isValidObject(this.state.toAddObject)) {
      this.props.onChange(event);
      this.setState({
        showOverlay: false,
        toAddObject: JavascriptUtilsTooling.deepCopy(initialObjectStates.default)
      });
    }
  };

  handleClickEdit = (event) => {
    let itemIndex = event.currentTarget.dataset.index;    
    let objectToEdit = JSON.parse(event.currentTarget.dataset.value);
    this.setState({  
      showOverlay: true,    
      toEditObjectPosition: itemIndex,
      toEditObject: objectToEdit
    });
  };

  handleChangeEdit = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    if(event.currentTarget.dataset.path == "transformation_type"){
      this.setState({
        toEditObject: {...initialObjectStates[value], order: this.state.toEditObject.order},
        showOverlay: true,
      });
    }
    else{
      var toEditObject = JavascriptUtilsTooling.deepCopy(this.state.toEditObject);
      toEditObject[event.currentTarget.dataset.path] = value;
      this.setState({
        toEditObject: toEditObject,
        showOverlay: true,
      });  
    }
  };

  handleCancelEdit = (event) => {
    this.setState({
      showOverlay: false,
      toEditObjectPosition: null,
      toEditObject: JavascriptUtilsTooling.deepCopy(initialObjectStates.default)
    });
  };

  handleSaveEditItem = (event) => {
    if(this.isValidObject(this.state.toEditObject)) {
      this.props.onChange(event);
      this.setState({
        showOverlay: false,
        toEditObjectPosition: null,
        toEditObject: JavascriptUtilsTooling.deepCopy(initialObjectStates.default)
      });   
    }     
  };

  handleOnEnterEditItem = (event) => {
    if(this.editItemSaveButton) {
      this.editItemSaveButton.click();      
    }   
  };

  render (){
    const {
      handleShowPopup,
      handleButton,
      className,
      popupState,
      formData,
      metricsList,
      transformationOptions,
      values,
      onChange,
      dataPath,
      usePivotColumn,
      disabled
    } = this.props;
  
    let label = ""
    let blockAdd = false;

    //Filter ColumnMapping or ColumnPivotMapping if its already selected
    let newtransformationOptions = (values ? values.find(item => (item.transformation_type == Constants.selectKeys.metricsGroupEtl.etlTransformations.COLUMN_MAPPING) || 
      (item.transformation_type == Constants.selectKeys.metricsGroupEtl.etlTransformations.COLUMN_PIVOT_MAPPING)
    ) : null) ?
      transformationOptions.filter(columnOption => columnOption.value != Constants.selectKeys.metricsGroupEtl.etlTransformations.COLUMN_MAPPING && 
        columnOption.value != Constants.selectKeys.metricsGroupEtl.etlTransformations.COLUMN_PIVOT_MAPPING
      ) :
      transformationOptions;

      //Dont allow Column_Pivot_Mapping transformations if usePivotColumn is false
      if(!usePivotColumn){
        newtransformationOptions = newtransformationOptions.filter(columnOption => columnOption.value != Constants.selectKeys.metricsGroupEtl.etlTransformations.COLUMN_PIVOT_MAPPING);
      }
      
      let sortedValues = values ? values.sort((a,b) => a.order - b.order) : null;
      newtransformationOptions = newtransformationOptions.sort((a,b) => a.label.localeCompare(b.label));
      return (
        <GlassPopup
        className={"form_popup etl_columns_transformations_editor_popup"}
        title={intl.formatMessage({id:"metricsGroupAdmin.etlColumnsTransformationsEditor.title"}) + ": " + label}
        {...this.props}
        >
        <div className={"custom-input free-text-list select-list object-editor etl_transformations_editor" + (className ? " " + className : "") + " select-list-no-search" + (className ? " " + className : "") + " select-list-no-search" + (this.state.showOverlay ? " free-text-list-overlay" : "")}>
          {this.state.showOverlay && (<div className="free-text-list-overlay-item"></div>)}
          <div className="free-text-list-label">            
            <FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.addButtonLabel"/>
            {(!disabled && !blockAdd) && (<i className="fas fa-plus-circle" onClick={this.handleAddButtonClick}/>)}
          </div>
            <div className="free-text-list-list-wrapper">
              {sortedValues && sortedValues.map((item,i) => {
                if(this.state.toEditObjectPosition == i) {
                  //Logic so that, if user is editing the Column_Mapping or Column_Pivot_Mapping transformation, that option is not filtered
                  if(item.transformation_type == Constants.selectKeys.metricsGroupEtl.etlTransformations.COLUMN_MAPPING) {
                    newtransformationOptions.push({value: item.transformation_type, label: intl.formatMessage({id:"metricsGroupAdmin.etlColumnsTransformationsEditor.etlTransformationsLabels.COLUMN_MAPPING"}) });
                    newtransformationOptions = newtransformationOptions.sort((a,b) => a.label.localeCompare(b.label));
                  }
                  if(item.transformation_type == Constants.selectKeys.metricsGroupEtl.etlTransformations.COLUMN_PIVOT_MAPPING) {
                    newtransformationOptions.push({value: item.transformation_type, label: intl.formatMessage({id:"metricsGroupAdmin.etlColumnsTransformationsEditor.etlTransformationsLabels.COLUMN_PIVOT_MAPPING"}) });
                    newtransformationOptions = newtransformationOptions.sort((a,b) => a.label.localeCompare(b.label));
                  }
                  return (
                    <div key={i} className="free-text-list-list-item free-text-list-list-item-edit">
                      <div className="free-text-list-list-item-inner object-editor-inputs">
                        <div className="object-editor-inputs-linebreak">
                          <Select
                            className="free-text-list-list-add-item"
                            value={this.state.toEditObject.transformation_type}
                            labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.transformation_type"/>}
                            options={newtransformationOptions}
                            onChange={this.handleChangeEdit}
                            data-path={"transformation_type"}
                            optionsTooltipsLocalesPath={"metricsGroupAdmin.etlColumnsTransformationsEditor.etlTransformationTooltips"}
                          />
                          {(this.state.toEditObject.transformation_type != Constants.selectKeys.metricsGroupEtl.etlTransformations.COLUMN_MAPPING &&
                            this.state.toEditObject.transformation_type != Constants.selectKeys.metricsGroupEtl.etlTransformations.COLUMN_PIVOT_MAPPING
                          ) && (
                            <TextBox
                              className="free-text-list-list-edit-item"
                              styleType={Constants.interface.inputs.styleType.OUTLINED}
                              onChange={this.handleChangeEdit}
                              data-path={"order"}
                              value={this.state.toEditObject.order}
                              onKeyEsc={this.handleCancelEdit}
                              onKeyEnter={this.handleOnEnterEditItem}
                              dataType={Constants.selectKeys.metric.dataType.NUMBER}
                              type={Constants.interface.inputs.type.TEXT}
                              labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.order"/>}
                              disabled={this.state.toEditObject.transformation_type == Constants.selectKeys.metricsGroupEtl.etlTransformations.COLUMN_MAPPING}
                            />
                          )}
                        </div>
                        {(this.state.toEditObject.transformation_type == Constants.selectKeys.metricsGroupEtl.etlTransformations.COLUMN_MAPPING) && (
                          <div className="object-editor-inputs-linebreak">
                            <TextBox
                              className="free-text-list-list-edit-item"
                              styleType={Constants.interface.inputs.styleType.OUTLINED}
                              onChange={this.handleChangeEdit}
                              data-path={"new_column_name"}
                              value={this.state.toEditObject.new_column_name}
                              onKeyEsc={this.handleCancelEdit}
                              onKeyEnter={this.handleOnEnterEditItem}
                              type={Constants.interface.inputs.type.TEXT}
                              dataType={Constants.selectKeys.metric.dataType.STRING}
                              labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.new_column_name"/>}
                            />
                            <TextBox
                              className="free-text-list-list-edit-item"
                              styleType={Constants.interface.inputs.styleType.OUTLINED}
                              onChange={this.handleChangeEdit}
                              data-path={"new_column_order"}
                              value={this.state.toEditObject.new_column_order}
                              onKeyEsc={this.handleCancelEdit}
                              onKeyEnter={this.handleOnEnterEditItem}
                              type={Constants.interface.inputs.type.TEXT}
                              dataType={Constants.selectKeys.metric.dataType.STRING}
                              labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.new_column_order"/>}
                            />
                          </div>
                        )}
                        {(this.state.toEditObject.transformation_type == Constants.selectKeys.metricsGroupEtl.etlTransformations.COLUMN_PIVOT_MAPPING) && (
                          <div className="object-editor-inputs-linebreak">
                            <Select
                              className="free-text-list-list-add-item"
                              value={this.state.toEditObject.new_column_choice}
                              labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.new_column_choice"/>}
                              options={InterfaceTooling.getSelectArray("selectKeys.metricsGroupEtl.mappingColumnPivotOptions","metricsGroupAdmin.etlColumnsTransformationsEditor.mappingColumnPivotOptionsLabels", false)}
                              onChange={this.handleChangeEdit}
                              data-path={"new_column_choice"}
                            />
                          </div>
                        )}
                        {(this.state.toEditObject.transformation_type == Constants.selectKeys.metricsGroupEtl.etlTransformations.REPLACE) && (
                          <div className="object-editor-inputs-linebreak">
                            <TextBox
                              className="free-text-list-list-edit-item"
                              styleType={Constants.interface.inputs.styleType.OUTLINED}
                              onChange={this.handleChangeEdit}
                              data-path={"text_to_replace"}
                              value={this.state.toEditObject.text_to_replace}
                              onKeyEsc={this.handleCancelEdit}
                              onKeyEnter={this.handleOnEnterEditItem}
                              type={Constants.interface.inputs.type.TEXT}
                              dataType={Constants.selectKeys.metric.dataType.STRING}
                              labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.text_to_replace"/>}
                            />
                            <TextBox
                              className="free-text-list-list-edit-item"
                              styleType={Constants.interface.inputs.styleType.OUTLINED}
                              onChange={this.handleChangeEdit}
                              data-path={"new_text"}
                              value={this.state.toEditObject.new_text}
                              onKeyEsc={this.handleCancelEdit}
                              onKeyEnter={this.handleOnEnterEditItem}
                              type={Constants.interface.inputs.type.TEXT}
                              dataType={Constants.selectKeys.metric.dataType.STRING}
                              labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.new_text"/>}
                            />
                          </div>
                        )}
                        {(this.state.toEditObject.transformation_type == Constants.selectKeys.metricsGroupEtl.etlTransformations.EXTRACT) && (
                          <React.Fragment>
                            <div className="object-editor-inputs-linebreak">
                              <div className="inputs_linebreak_label">
                                <span><FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.extractStartLabel"/>{" ->"}</span>
                              </div>
                              <Select
                                className="free-text-list-list-add-item extract_type"
                                value={this.state.toEditObject.extract_start_type}
                                labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.extract_start_type"/>}
                                options={InterfaceTooling.getSelectArray("selectKeys.metricsGroupEtl.extractIntervalSelectorType","metricsGroupAdmin.etlColumnsTransformationsEditor.extractIntervalSelectorTypeLabels")}
                                onChange={this.handleChangeEdit}
                                data-path={"extract_start_type"}
                              />
                              <TextBox
                                className="free-text-list-list-edit-item"
                                styleType={Constants.interface.inputs.styleType.OUTLINED}
                                onChange={this.handleChangeEdit}
                                data-path={"extract_start_value"}
                                value={this.state.toEditObject.extract_start_value}
                                onKeyEsc={this.handleCancelEdit}
                                onKeyEnter={this.handleOnEnterEditItem}
                                type={Constants.interface.inputs.type.TEXT}
                                dataType={Constants.selectKeys.metric.dataType.STRING}
                                labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.extract_start_value"/>}
                              />
                              {(this.state.toEditObject.extract_start_type == Constants.selectKeys.metricsGroupEtl.extractIntervalSelectorType.INDEXOF) && (
                                <TextBox
                                  className="free-text-list-list-edit-item"
                                  styleType={Constants.interface.inputs.styleType.OUTLINED}
                                  onChange={this.handleChangeEdit}
                                  data-path={"extract_start_deviation"}
                                  value={this.state.toEditObject.extract_start_deviation}
                                  onKeyEsc={this.handleCancelEdit}
                                  onKeyEnter={this.handleOnEnterEditItem}
                                  type={Constants.interface.inputs.type.TEXT}
                                  dataType={Constants.selectKeys.metric.dataType.NUMBER}
                                  labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.extract_start_deviation"/>}
                                />
                              )}
                            </div>
                            <div className="object-editor-inputs-linebreak">
                              <div className="inputs_linebreak_label">
                                <span><FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.extractEndLabel"/>{" ->"}</span>
                              </div>
                              <Select
                                className="free-text-list-list-add-item extract_type"
                                value={this.state.toEditObject.extract_end_type}
                                labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.extract_end_type"/>}
                                options={InterfaceTooling.getSelectArray("selectKeys.metricsGroupEtl.extractIntervalSelectorType","metricsGroupAdmin.etlColumnsTransformationsEditor.extractIntervalSelectorTypeLabels")}
                                onChange={this.handleChangeEdit}
                                data-path={"extract_end_type"}
                              />
                              <TextBox
                                className="free-text-list-list-edit-item"
                                styleType={Constants.interface.inputs.styleType.OUTLINED}
                                onChange={this.handleChangeEdit}
                                data-path={"extract_end_value"}
                                value={this.state.toEditObject.extract_end_value}
                                onKeyEsc={this.handleCancelEdit}
                                onKeyEnter={this.handleOnEnterEditItem}
                                type={Constants.interface.inputs.type.TEXT}
                                dataType={Constants.selectKeys.metric.dataType.STRING}
                                labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.extract_end_value"/>}
                              />
                              {(this.state.toEditObject.extract_end_type == Constants.selectKeys.metricsGroupEtl.extractIntervalSelectorType.INDEXOF) && (
                                <TextBox
                                  className="free-text-list-list-edit-item"
                                  styleType={Constants.interface.inputs.styleType.OUTLINED}
                                  onChange={this.handleChangeEdit}
                                  data-path={"extract_end_deviation"}
                                  value={this.state.toEditObject.extract_end_deviation}
                                  onKeyEsc={this.handleCancelEdit}
                                  onKeyEnter={this.handleOnEnterEditItem}
                                  type={Constants.interface.inputs.type.TEXT}
                                  dataType={Constants.selectKeys.metric.dataType.NUMBER}
                                  labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.extract_end_deviation"/>}
                                />
                              )}
                            </div>
                          </React.Fragment>
                        )}
                        {(this.state.toEditObject.transformation_type == Constants.selectKeys.metricsGroupEtl.etlTransformations.MAPCOLUMNWITHHASHMETRIC) && (
                          <React.Fragment>
                            <div className="object-editor-inputs-linebreak">
                              <Select
                                className="free-text-list-list-add-item"
                                value={this.state.toEditObject.metric_to_map}
                                labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.metric_to_map"/>}
                                options={InterfaceTooling.getSelectArrayFromArrayOfObjects(metricsList, "id", "name")}
                                onChange={this.handleChangeEdit}
                                data-path={"metric_to_map"}
                              />
                              <Select
                                className="free-text-list-list-add-item"
                                value={this.state.toEditObject.mapping_column}
                                labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.mapping_column"/>}
                                options={this.state.toEditObject.metric_to_map ? 
                                  [...InterfaceTooling.getSelectArrayFromArrayOfObjects(metricsList.find(metric => metric.id == this.state.toEditObject.metric_to_map).dimension_hash, "id", "name"),
                                    {value: "metric_value", label: intl.formatMessage({id:"metricsGroupAdmin.etlColumnsTransformationsEditor.metricValueLabel"})}] : []}
                                onChange={this.handleChangeEdit}
                                data-path={"mapping_column"}
                                disabled={!this.state.toEditObject.metric_to_map}
                              />
                            </div>
                            <div className="object-editor-inputs-linebreak">
                              <Select
                                className="free-text-list-list-add-item"
                                value={this.state.toEditObject.result_column}
                                labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.result_column"/>}
                                onChange={this.handleChangeEdit}
                                options={this.state.toEditObject.metric_to_map ? 
                                  [...InterfaceTooling.getSelectArrayFromArrayOfObjects(metricsList.find(metric => metric.id == this.state.toEditObject.metric_to_map).dimension_hash, "id", "name"),
                                    {value: "metric_value", label: intl.formatMessage({id:"metricsGroupAdmin.etlColumnsTransformationsEditor.metricValueLabel"})}] : []}
                                data-path={"result_column"}
                              />
                              <TextBox
                                className="free-text-list-list-edit-item"
                                styleType={Constants.interface.inputs.styleType.OUTLINED}
                                onChange={this.handleChangeEdit}
                                data-path={"default_value"}
                                value={this.state.toEditObject.default_value}
                                onKeyEsc={this.handleCancelEdit}
                                onKeyEnter={this.handleOnEnterEditItem}
                                type={Constants.interface.inputs.type.TEXT}
                                labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.default_value"/>}
                              />
                            </div>
                          </React.Fragment>
                          
                        )}
                      </div>
                      {!disabled && (
                        <div className="free-text-list-list-item-action-buttons free-text-list-list-item-action-buttons-edit">
                          <i 
                            ref={(input) => { this.editItemSaveButton = input; }}
                            className="fas fa-save"
                            data-index={i}                        
                            data-value={JSON.stringify(this.state.toEditObject)}
                            data-objecteditor={"true"}
                            data-path={dataPath}
                            data-edit={"true"}
                            onClick={this.handleSaveEditItem}                      
                          />         
                          <i className="fas cancel-action fa-times-circle" onClick={this.handleCancelEdit}/>
                        </div>
                      )}
                    </div>
                  );
                }
                else {
                  let itemInnerText = item.order ? "[" + item.order + "] " : "[0] ";
                  itemInnerText += intl.formatMessage({ id: "metricsGroupAdmin.etlColumnsTransformationsEditor.etlTransformationsLabels." + item.transformation_type});
                  switch(item.transformation_type){
                    case Constants.selectKeys.metricsGroupEtl.etlTransformations.COLUMN_MAPPING:
                      itemInnerText += " -> \"" + item.new_column_name + "\"";
                      itemInnerText += item.new_column_order ? (" (" + intl.formatMessage({ id: "metricsGroupAdmin.etlColumnsTransformationsEditor.newColumnOrderLabel" }) + item.new_column_order + ")") : "";
                      break;
                    case Constants.selectKeys.metricsGroupEtl.etlTransformations.REPLACE:
                      itemInnerText += ": '" + item.text_to_replace + "' -> '" + item.new_text + "'";
                      if(!item.new_text){
                        itemInnerText += intl.formatMessage({ id: "metricsGroupAdmin.etlColumnsTransformationsEditor.emptyNewTextDisclaimer" });
                      }
                      break;
                    case Constants.selectKeys.metricsGroupEtl.etlTransformations.EXTRACT:
                      itemInnerText += ": " + intl.formatMessage({ id: "metricsGroupAdmin.etlColumnsTransformationsEditor.extractStartLabel" }) + " " + intl.formatMessage({ id: "metricsGroupAdmin.etlColumnsTransformationsEditor.extractTypeLabel."+item.extract_start_type}) + " ";
                      itemInnerText += item.extract_start_type==Constants.selectKeys.metricsGroupEtl.extractIntervalSelectorType.INDEXOF ? ("\"" + item.extract_start_value + "\"") : item.extract_start_value;
                      itemInnerText += item.extract_start_deviation ? (" (" + intl.formatMessage({ id: "metricsGroupAdmin.etlColumnsTransformationsEditor.extractDeviationLabel" }) + " " + item.extract_start_deviation + ")") : "";
                      itemInnerText += " -> " + intl.formatMessage({ id: "metricsGroupAdmin.etlColumnsTransformationsEditor.extractEndLabel" }) + " " + intl.formatMessage({ id: "metricsGroupAdmin.etlColumnsTransformationsEditor.extractTypeLabel."+item.extract_end_type}) + " ";
                      itemInnerText += item.extract_end_type==Constants.selectKeys.metricsGroupEtl.extractIntervalSelectorType.INDEXOF ? ("\"" + item.extract_end_value + "\"") : item.extract_end_value;
                      itemInnerText += item.extract_end_deviation ? (" (" + intl.formatMessage({ id: "metricsGroupAdmin.etlColumnsTransformationsEditor.extractDeviationLabel" }) + " " + item.extract_end_deviation + ")") : "";
                      break;
                    case Constants.selectKeys.metricsGroupEtl.etlTransformations.MAPCOLUMNWITHHASHMETRIC:
                      itemInnerText += " \"" + metricsList.find(metric => metric.id == item.metric_to_map).name + "\" -> "
                      itemInnerText += intl.formatMessage({ id: "metricsGroupAdmin.etlColumnsTransformationsEditor.fields.mapping_column" }) + ": \""
                      itemInnerText += (item.mapping_column=="metric_value" ? intl.formatMessage({id:"metricsGroupAdmin.etlColumnsTransformationsEditor.metricValueLabel"}) : metricsList.find(metric => metric.id == item.metric_to_map).dimension_hash.find(dimension => dimension.id == item.mapping_column).name) + "\" - "
                      itemInnerText += intl.formatMessage({ id: "metricsGroupAdmin.etlColumnsTransformationsEditor.fields.result_column" }) + ": \"" 
                      itemInnerText += (item.result_column=="metric_value" ? intl.formatMessage({id:"metricsGroupAdmin.etlColumnsTransformationsEditor.metricValueLabel"}) : metricsList.find(metric => metric.id == item.metric_to_map).dimension_hash.find(dimension => dimension.id == item.result_column).name) + "\""
                      itemInnerText += item.default_value ? (" (" + intl.formatMessage({ id: "metricsGroupAdmin.etlColumnsTransformationsEditor.fields.default_value" }) + ": " + item.default_value + ")") : "";
                      break;
                    case Constants.selectKeys.metricsGroupEtl.etlTransformations.COLUMN_PIVOT_MAPPING:
                      itemInnerText += " -> " + intl.formatMessage({id: "metricsGroupAdmin.etlColumnsTransformationsEditor.mappingColumnPivotOptionsLabels."+ item.new_column_choice});
                      break;
                    default:
                      break;
                  }
                  return (
                    <div key={i} className={"free-text-list-list-item"}>
                      <div title={itemInnerText} className="free-text-list-list-item-inner">
                        {itemInnerText}
                      </div>
                      {!disabled && (
                        <div className="free-text-list-list-item-action-buttons">
                          <HoverTooltip 
                            toolTip={intl.formatMessage({id: "metricsGroupAdmin.etlColumnsTransformationsEditor.etlTransformationTooltips."+item.transformation_type})}
                            toolTipType={Constants.interface.toolTip.formItemHelp}
                            enterDelay={300} 
                            leaveDelay={100}
                            placement={"left"}
                          >
                            <i 
                              className="fas fa-question"
                            />
                          </HoverTooltip>
                          <i 
                            className="fas fa-edit"
                            onClick={this.handleClickEdit}
                            data-index={i}
                            data-value={JSON.stringify(item)}
                          />
                          <i
                            className="fas delete-action fa-trash"                          
                            data-index={i}
                            data-delete={"true"}
                            data-objecteditor={"true"}
                            data-value={JSON.stringify(item)}
                            data-path={dataPath}
                            onClick={onChange}
                          />
                        </div>
                      )}
                    </div>
                  );
                }
              })}
              <div className="free-text-list-list-item free-text-list-list-item-add">
                <div className="free-text-list-list-item-inner">
                  {(!disabled && !blockAdd) && (
                    <div className="object-editor-inputs">
                      <div className="object-editor-inputs-linebreak">
                        <Select
                          className="free-text-list-list-add-item"
                          value={this.state.toAddObject.transformation_type}
                          labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.transformation_type"/>}
                          options={newtransformationOptions}
                          onChange={this.handleChangeAddItem}
                          data-path={"transformation_type"}                          
                          optionsTooltipsLocalesPath={"metricsGroupAdmin.etlColumnsTransformationsEditor.etlTransformationTooltips"}
                          ref={(input) => { this.editItemInput = input; }}
                        />
                        {(this.state.toAddObject.transformation_type != Constants.selectKeys.metricsGroupEtl.etlTransformations.COLUMN_MAPPING &&
                          this.state.toAddObject.transformation_type != Constants.selectKeys.metricsGroupEtl.etlTransformations.COLUMN_PIVOT_MAPPING
                        ) && (
                          <TextBox
                            className="free-text-list-list-add-item"
                            styleType={Constants.interface.inputs.styleType.OUTLINED}
                            onChange={this.handleChangeAddItem}
                            data-path={"order"}
                            value={this.state.toAddObject.order}
                            onKeyEsc={this.handleCancelAdd}
                            onKeyEnter={this.handleOnEnterAddItem}
                            type={Constants.interface.inputs.type.TEXT}
                            dataType={Constants.selectKeys.metric.dataType.NUMBER}
                            labelLocale={<FormattedMessage id="reportTemplateAdmin.metricDetailColumnsEditor.metricColumnsLabels.order"/>}
                            disabled={this.state.toAddObject.transformation_type == Constants.selectKeys.metricsGroupEtl.etlTransformations.COLUMN_MAPPING}
                          />
                        )}
                        </div>
                        {(this.state.toAddObject.transformation_type == Constants.selectKeys.metricsGroupEtl.etlTransformations.COLUMN_MAPPING) && (
                          <div className="object-editor-inputs-linebreak">
                            <TextBox
                              className="free-text-list-list-edit-item"
                              styleType={Constants.interface.inputs.styleType.OUTLINED}
                              onChange={this.handleChangeAddItem}
                              data-path={"new_column_name"}
                              value={this.state.toAddObject.new_column_name}
                              onKeyEsc={this.handleCancelAdd}
                              onKeyEnter={this.handleOnEnterAddItem}
                              type={Constants.interface.inputs.type.TEXT}
                              labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.new_column_name"/>}
                            />
                            <TextBox
                              className="free-text-list-list-edit-item"
                              styleType={Constants.interface.inputs.styleType.OUTLINED}
                              onChange={this.handleChangeAddItem}
                              data-path={"new_column_order"}
                              value={this.state.toAddObject.new_column_order}
                              onKeyEsc={this.handleCancelAdd}
                              onKeyEnter={this.handleOnEnterAddItem}
                              type={Constants.interface.inputs.type.TEXT}
                              labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.new_column_order"/>}
                            />
                          </div>
                        )}
                        {(this.state.toAddObject.transformation_type == Constants.selectKeys.metricsGroupEtl.etlTransformations.COLUMN_PIVOT_MAPPING) && (
                          <div className="object-editor-inputs-linebreak">
                            <Select
                              className="free-text-list-list-add-item"
                              value={this.state.toAddObject.new_column_choice}
                              labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.new_column_choice"/>}
                              options={InterfaceTooling.getSelectArray("selectKeys.metricsGroupEtl.mappingColumnPivotOptions","metricsGroupAdmin.etlColumnsTransformationsEditor.mappingColumnPivotOptionsLabels")}
                              onChange={this.handleChangeAddItem}
                              data-path={"new_column_choice"}
                            />
                          </div>  
                        )}
                        {(this.state.toAddObject.transformation_type == Constants.selectKeys.metricsGroupEtl.etlTransformations.REPLACE) && (
                          <div className="object-editor-inputs-linebreak">
                            <TextBox
                              className="free-text-list-list-edit-item"
                              styleType={Constants.interface.inputs.styleType.OUTLINED}
                              onChange={this.handleChangeAddItem}
                              data-path={"text_to_replace"}
                              value={this.state.toAddObject.text_to_replace}
                              onKeyEsc={this.handleCancelAdd}
                              onKeyEnter={this.handleOnEnterAddItem}
                              type={Constants.interface.inputs.type.TEXT}
                              dataType={Constants.selectKeys.metric.dataType.STRING}
                              labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.text_to_replace"/>}
                            />
                            <TextBox
                              className="free-text-list-list-edit-item"
                              styleType={Constants.interface.inputs.styleType.OUTLINED}
                              onChange={this.handleChangeAddItem}
                              data-path={"new_text"}
                              value={this.state.toAddObject.new_text}
                              onKeyEsc={this.handleCancelAdd}
                              onKeyEnter={this.handleOnEnterAddItem}
                              type={Constants.interface.inputs.type.TEXT}
                              dataType={Constants.selectKeys.metric.dataType.STRING}
                              labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.new_text"/>}
                            />
                          </div>
                        )}
                        {(this.state.toAddObject.transformation_type == Constants.selectKeys.metricsGroupEtl.etlTransformations.EXTRACT) && (
                          <React.Fragment>
                            <div className="object-editor-inputs-linebreak">
                              <div className="inputs_linebreak_label">
                                <span><FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.extractStartLabel"/>{" ->"}</span>
                              </div>
                              <Select
                                className="free-text-list-list-add-item extract_type"
                                value={this.state.toAddObject.extract_start_type}
                                labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.extract_start_type"/>}
                                options={InterfaceTooling.getSelectArray("selectKeys.metricsGroupEtl.extractIntervalSelectorType","metricsGroupAdmin.etlColumnsTransformationsEditor.extractIntervalSelectorTypeLabels")}
                                onChange={this.handleChangeAddItem}
                                data-path={"extract_start_type"}
                              />
                              <TextBox
                                className="free-text-list-list-edit-item"
                                styleType={Constants.interface.inputs.styleType.OUTLINED}
                                onChange={this.handleChangeAddItem}
                                data-path={"extract_start_value"}
                                value={this.state.toAddObject.extract_start_value}
                                onKeyEsc={this.handleCancelAdd}
                                onKeyEnter={this.handleOnEnterAddItem}
                                type={Constants.interface.inputs.type.TEXT}
                                dataType={Constants.selectKeys.metric.dataType.STRING}
                                labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.extract_start_value"/>}
                              />
                              {(this.state.toAddObject.extract_start_type == Constants.selectKeys.metricsGroupEtl.extractIntervalSelectorType.INDEXOF) && (
                                <TextBox
                                  className="free-text-list-list-edit-item"
                                  styleType={Constants.interface.inputs.styleType.OUTLINED}
                                  onChange={this.handleChangeAddItem}
                                  data-path={"extract_start_deviation"}
                                  value={this.state.toAddObject.extract_start_deviation}
                                  onKeyEsc={this.handleCancelAdd}
                                  onKeyEnter={this.handleOnEnterAddItem}
                                  type={Constants.interface.inputs.type.TEXT}
                                  dataType={Constants.selectKeys.metric.dataType.NUMBER}
                                  labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.extract_start_deviation"/>}
                                />
                              )}
                            </div>
                            <div className="object-editor-inputs-linebreak">
                              <div className="inputs_linebreak_label">
                                <span><FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.extractEndLabel"/>{" ->"}</span>
                              </div>
                              <Select
                                className="free-text-list-list-add-item extract_type"
                                value={this.state.toAddObject.extract_end_type}
                                labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.extract_end_type"/>}
                                options={InterfaceTooling.getSelectArray("selectKeys.metricsGroupEtl.extractIntervalSelectorType","metricsGroupAdmin.etlColumnsTransformationsEditor.extractIntervalSelectorTypeLabels")}
                                onChange={this.handleChangeAddItem}
                                data-path={"extract_end_type"}
                              />
                              <TextBox
                                className="free-text-list-list-edit-item"
                                styleType={Constants.interface.inputs.styleType.OUTLINED}
                                onChange={this.handleChangeAddItem}
                                data-path={"extract_end_value"}
                                value={this.state.toAddObject.extract_end_value}
                                onKeyEsc={this.handleCancelAdd}
                                onKeyEnter={this.handleOnEnterAddItem}
                                type={Constants.interface.inputs.type.TEXT}
                                dataType={Constants.selectKeys.metric.dataType.STRING}
                                labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.extract_end_value"/>}
                              />
                              {(this.state.toAddObject.extract_end_type == Constants.selectKeys.metricsGroupEtl.extractIntervalSelectorType.INDEXOF) && (
                                <TextBox
                                  className="free-text-list-list-edit-item"
                                  styleType={Constants.interface.inputs.styleType.OUTLINED}
                                  onChange={this.handleChangeAddItem}
                                  data-path={"extract_end_deviation"}
                                  value={this.state.toAddObject.extract_end_deviation}
                                  onKeyEsc={this.handleCancelAdd}
                                  onKeyEnter={this.handleOnEnterAddItem}
                                  type={Constants.interface.inputs.type.TEXT}
                                  dataType={Constants.selectKeys.metric.dataType.NUMBER}
                                  labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.extract_end_deviation"/>}
                                />
                              )}
                            </div>
                          </React.Fragment>
                        )}
                        {(this.state.toAddObject.transformation_type == Constants.selectKeys.metricsGroupEtl.etlTransformations.MAPCOLUMNWITHHASHMETRIC) && (
                          <React.Fragment>
                            <div className="object-editor-inputs-linebreak">
                              <Select
                                className="free-text-list-list-add-item"
                                value={this.state.toAddObject.metric_to_map}
                                labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.metric_to_map"/>}
                                options={InterfaceTooling.getSelectArrayFromArrayOfObjects(metricsList, "id", "name")}
                                onChange={this.handleChangeAddItem}
                                data-path={"metric_to_map"}
                              />
                              <Select
                                className="free-text-list-list-add-item"
                                value={this.state.toAddObject.mapping_column}
                                labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.mapping_column"/>}
                                options={this.state.toAddObject.metric_to_map ?
                                  [...InterfaceTooling.getSelectArrayFromArrayOfObjects(metricsList.find(metric => metric.id == this.state.toAddObject.metric_to_map).dimension_hash, "id", "name"),
                                    {value: "metric_value", label: intl.formatMessage({id:"metricsGroupAdmin.etlColumnsTransformationsEditor.metricValueLabel"})}] : []}
                                onChange={this.handleChangeAddItem}
                                data-path={"mapping_column"}
                                disabled={!this.state.toAddObject.metric_to_map}
                              />
                            </div>
                            <div className="object-editor-inputs-linebreak">
                              <Select
                                className="free-text-list-list-add-item"
                                value={this.state.toAddObject.result_column}
                                labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.result_column"/>}
                                onChange={this.handleChangeAddItem}
                                options={this.state.toAddObject.metric_to_map ?
                                  [...InterfaceTooling.getSelectArrayFromArrayOfObjects(metricsList.find(metric => metric.id == this.state.toAddObject.metric_to_map).dimension_hash, "id", "name"),
                                    {value: "metric_value", label: intl.formatMessage({id:"metricsGroupAdmin.etlColumnsTransformationsEditor.metricValueLabel"})}] : []}
                                data-path={"result_column"}
                              />
                              <TextBox
                                className="free-text-list-list-edit-item"
                                styleType={Constants.interface.inputs.styleType.OUTLINED}
                                onChange={this.handleChangeAddItem}
                                data-path={"default_value"}
                                value={this.state.toAddObject.default_value}
                                onKeyEsc={this.handleCancelAdd}
                                onKeyEnter={this.handleOnEnterAddItem}
                                type={Constants.interface.inputs.type.TEXT}
                                labelLocale={<FormattedMessage id="metricsGroupAdmin.etlColumnsTransformationsEditor.fields.default_value"/>}
                              />
                            </div>
                          </React.Fragment>
                        )}
                    </div>
                  )}
                </div>
                {(!disabled && !blockAdd) && (
                  <div className="free-text-list-list-item-action-buttons free-text-list-list-item-action-buttons-add">
                    <i 
                      ref={(input) => { this.addItemSaveButton = input; }}
                      className="fas fa-save"
                      data-objecteditor={"true"}
                      data-value={JSON.stringify(this.state.toAddObject)}
                      data-path={dataPath}
                      onClick={this.handleSaveAddItem}   
                    />
                    <i 
                      className="fas cancel-action fa-times-circle"
                      onClick={this.handleCancelAdd}
                    />
                  </div>
                )}
              </div>
            </div>
        </div>
      </GlassPopup>
    );
  }
};

export default EtlTransformationsEditorPopup;



// WEBPACK FOOTER //
// ./source/client/components/metricsGroupAdmin/etlTransformationsEditorPopup.jsx